var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return !_vm.isResellerSubAccount
    ? _c(
        "v-row",
        _vm._b({}, "v-row", _vm.$attrs, false),
        [
          _c(
            "v-col",
            {
              attrs: {
                cols: "12"
              }
            },
            [
              _c(
                "gg-card",
                [
                  _c(
                    "gg-card-text",
                    [
                      _c(
                        "div",
                        {
                          staticClass: "body-1 mb-5"
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "pb-1",
                              attrs: {
                                size: "24",
                                color: "primary"
                              }
                            },
                            [_vm._v("mdi-account-settings")]
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "ml-2 font-weight-medium"
                            },
                            [_vm._v(_vm._s(_vm.serviceInfoTitle))]
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "pl-4 pr-9",
                              attrs: {
                                cols: "6"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "justify-content": "space-between",
                                    "flex-wrap": "wrap",
                                    gap: "6px"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "font-weight-bold",
                                      staticStyle: {
                                        flex: "0 0 45%"
                                      }
                                    },
                                    [_vm._v("Plan Type:")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        flex: "0 0 45%",
                                        "text-align": "right"
                                      }
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          " " + _vm._s(_vm.hosting.name) + " "
                                        )
                                      ]),
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            size: "medium"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.iconFlag(_vm.hosting.flag)
                                              ) +
                                              " "
                                          )
                                        ]
                                      ),
                                      _vm.hosting.changeplan
                                        ? _c(
                                            "a",
                                            {
                                              staticClass: "ml-5",
                                              attrs: {
                                                href: "#"
                                              },
                                              on: {
                                                click: function click($event) {
                                                  $event.preventDefault()
                                                  return _vm.handleChangePlan(
                                                    $event
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v(" Change Plan ")]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "font-weight-bold",
                                      staticStyle: {
                                        flex: "0 0 45%"
                                      }
                                    },
                                    [_vm._v("Status:")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        flex: "0 0 45%",
                                        "text-align": "right"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "pb-1",
                                          attrs: {
                                            small: "",
                                            color: _vm.statusColor(
                                              _vm.hosting.status
                                            )
                                          }
                                        },
                                        [_vm._v("mdi-circle")]
                                      ),
                                      _c("span", [
                                        _vm._v(
                                          " " + _vm._s(_vm.hosting.status) + " "
                                        )
                                      ])
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "font-weight-bold",
                                      staticStyle: {
                                        flex: "0 0 45%"
                                      }
                                    },
                                    [_vm._v("Billing Cycle:")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        flex: "0 0 45%",
                                        "text-align": "right"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.hosting.renewalterm) +
                                          " "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "font-weight-bold",
                                      staticStyle: {
                                        flex: "0 0 45%"
                                      }
                                    },
                                    [_vm._v("Renewal Date:")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex justify-end align-center text-right",
                                      staticStyle: {
                                        flex: "0 0 45%",
                                        gap: "1rem"
                                      }
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatRenewalDate(
                                              _vm.parseRenewalDate(
                                                _vm.hosting.renewaldate
                                              )
                                            )
                                          )
                                        )
                                      ]),
                                      _vm.currentHosting
                                        .can_access_early_renewal
                                        ? _c(
                                            "a",
                                            {
                                              attrs: {
                                                href: "#"
                                              },
                                              on: {
                                                click: function click($event) {
                                                  $event.preventDefault()
                                                  return _vm.handleRenewNow(
                                                    $event
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v(" Renew Now ")]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                ]
                              )
                            ]
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "pl-9 pr-4",
                              attrs: {
                                cols: "6"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "justify-content": "space-between",
                                    "flex-wrap": "wrap",
                                    gap: "6px"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "font-weight-bold",
                                      staticStyle: {
                                        flex: "0 0 45%"
                                      }
                                    },
                                    [_vm._v("Password Management:")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        flex: "0 0 45%",
                                        "text-align": "right"
                                      }
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: "#"
                                          },
                                          on: {
                                            click: function click($event) {
                                              return _vm.openChangePasswordModal(
                                                $event,
                                                _vm.hosting_detail
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v(" Change Password ")]
                                      )
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "font-weight-bold",
                                      staticStyle: {
                                        flex: "0 0 45%"
                                      }
                                    },
                                    [_vm._v("Sharing Options:")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        flex: "0 0 45%",
                                        "text-align": "right"
                                      }
                                    },
                                    [
                                      _vm.hosting.sharedaccount ||
                                      _vm.hosting.sharedaccess
                                        ? _c("shared-service-tag", {
                                            attrs: {
                                              service: _vm.hosting
                                            }
                                          })
                                        : _c(
                                            "router-link",
                                            {
                                              attrs: {
                                                to: {
                                                  name: "profile_access"
                                                }
                                              }
                                            },
                                            [_vm._v(" Enable Sharing ")]
                                          )
                                    ],
                                    1
                                  ),
                                  _vm.currentHosting.cancellation_type ===
                                  "addon"
                                    ? [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "font-weight-bold",
                                            staticStyle: {
                                              flex: "0 0 45%"
                                            }
                                          },
                                          [_vm._v("Addon Cancellation:")]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              flex: "0 0 45%",
                                              "text-align": "right"
                                            }
                                          },
                                          [
                                            _c(
                                              "router-link",
                                              {
                                                attrs: {
                                                  to: "/cancellations/".concat(
                                                    _vm.currentHosting
                                                      .cancellation_id
                                                  ),
                                                  "aria-label": "View Request"
                                                }
                                              },
                                              [_vm._v(" View Request ")]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    : _vm._e(),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "font-weight-bold",
                                      staticStyle: {
                                        flex: "0 0 45%"
                                      }
                                    },
                                    [_vm._v("Auto Renew:")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        flex: "0 0 45%",
                                        "text-align": "right"
                                      }
                                    },
                                    [
                                      _vm.currentHosting.autorenew
                                        ? _c(
                                            "div",
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass: "pb-1",
                                                  attrs: {
                                                    small: "",
                                                    color: _vm.statusColor(1)
                                                  }
                                                },
                                                [_vm._v("mdi-circle")]
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "pl-1"
                                                },
                                                [_vm._v("Enabled")]
                                              ),
                                              _vm.currentHosting.autorenew
                                                ? _c(
                                                    "router-link",
                                                    {
                                                      staticClass: "ml-4",
                                                      attrs: {
                                                        to: {
                                                          name: "cancel",
                                                          params: {
                                                            service_id:
                                                              _vm.hosting.id
                                                          },
                                                          query: {
                                                            type:
                                                              _vm
                                                                .cancellationTypes
                                                                .HOSTING
                                                          }
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.hosting
                                                              .status ===
                                                              "Suspended"
                                                              ? "Submit Cancellation"
                                                              : "Disable"
                                                          ) +
                                                          " "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        : _c(
                                            "div",
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass: "pb-1",
                                                  attrs: {
                                                    small: "",
                                                    color: _vm.statusColor(0)
                                                  }
                                                },
                                                [_vm._v("mdi-circle")]
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "font-bold pl-1"
                                                },
                                                [_vm._v("Disabled")]
                                              ),
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href: "#"
                                                  },
                                                  on: {
                                                    click:
                                                      _vm.canAutorenewProceed
                                                  }
                                                },
                                                [_vm._v(" Enable ")]
                                              )
                                            ],
                                            1
                                          )
                                    ]
                                  )
                                ],
                                2
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c("gg-modal", {
                        attrs: {
                          "is-active": _vm.autorenewModalOpen
                        },
                        on: {
                          close: _vm.closeModalAutorenew
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "toolbar",
                              fn: function fn() {
                                return [_vm._v(" Enabling auto renew error ")]
                              },
                              proxy: true
                            },
                            {
                              key: "body",
                              fn: function fn() {
                                return [
                                  _vm._v(
                                    " Your service is not eligible to enable auto renew. Please contact Billing for assistance. "
                                  )
                                ]
                              },
                              proxy: true
                            },
                            {
                              key: "actions",
                              fn: function fn() {
                                return [
                                  _c(
                                    "gg-btn",
                                    {
                                      on: {
                                        click: _vm.closeModalAutorenew
                                      }
                                    },
                                    [_vm._v("Close")]
                                  )
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          false,
                          3991906719
                        )
                      }),
                      _c("gg-modal", {
                        attrs: {
                          "is-active": _vm.autorenewModalConfirmOpen
                        },
                        on: {
                          close: _vm.closeModalAutorenewConfirm
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "toolbar",
                              fn: function fn() {
                                return [_vm._v(" Enabling auto renew ")]
                              },
                              proxy: true
                            },
                            {
                              key: "body",
                              fn: function fn() {
                                return [
                                  _c("p", [
                                    _vm._v(
                                      "This service will be set to auto-renew. Our system will automatically renew your account to ensure your account stays active."
                                    )
                                  ]),
                                  _c("p", [
                                    _vm._v(
                                      "Are you sure you want to enable auto renewal?"
                                    )
                                  ])
                                ]
                              },
                              proxy: true
                            },
                            {
                              key: "actions",
                              fn: function fn() {
                                return [
                                  _c(
                                    "gg-btn",
                                    {
                                      attrs: {
                                        secondary: ""
                                      },
                                      on: {
                                        click: _vm.closeModalAutorenewConfirm
                                      }
                                    },
                                    [_vm._v("No")]
                                  ),
                                  _c(
                                    "gg-btn",
                                    {
                                      attrs: {
                                        primary: "",
                                        loading: _vm.autorenewLoading
                                      },
                                      on: {
                                        click: _vm.acceptModalAutorenewConfirm
                                      }
                                    },
                                    [_vm._v("Yes")]
                                  )
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          false,
                          3712926844
                        )
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("gg-modal", {
                attrs: {
                  "is-active": _vm.modalChangePassword
                },
                on: {
                  close: _vm.closeChangePasswordModal
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "toolbar",
                      fn: function fn() {
                        return [_vm._v(" Change Password ")]
                      },
                      proxy: true
                    },
                    {
                      key: "body",
                      fn: function fn() {
                        return [
                          _c("compact-password", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: _vm.modalChangePassword
                                  ? "required|min:8"
                                  : "",
                                expression:
                                  "modalChangePassword ? 'required|min:8' : ''"
                              }
                            ],
                            attrs: {
                              outlined: "",
                              "cpanel-app": "passwd",
                              label: "New Password for ".concat(_vm.user),
                              "show-strength": "",
                              "with-generator": "",
                              charset:
                                "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMOPRSTUVWXYZ0123456789_",
                              autocomplete: "new-password",
                              "data-vv-name": "password",
                              "data-vv-as": "Password",
                              "error-messages": _vm.errors.collect("password")
                            },
                            model: {
                              value: _vm.password,
                              callback: function callback($$v) {
                                _vm.password = $$v
                              },
                              expression: "password"
                            }
                          })
                        ]
                      },
                      proxy: true
                    },
                    {
                      key: "actions",
                      fn: function fn() {
                        return [
                          _c(
                            "gg-btn",
                            {
                              attrs: {
                                secondary: ""
                              },
                              on: {
                                click: _vm.closeChangePasswordModal
                              }
                            },
                            [_vm._v(" Cancel ")]
                          ),
                          _c(
                            "gg-btn",
                            {
                              attrs: {
                                primary: "",
                                loading: _vm.isUpdatingPassword
                              },
                              on: {
                                click: _vm.updatePassword
                              }
                            },
                            [_vm._v(" Change ")]
                          )
                        ]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  false,
                  1951230482
                )
              }),
              _c("renew-now-modal", {
                ref: "renewNowModal",
                attrs: {
                  "preferred-term": _vm.renewNowTerm
                }
              })
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }